module.exports = __webpack_public_path__ + "img/mp.6548ef7d.svg";